import { wxworkConfig } from './wechat'

export function loadJs(url) {
  return new Promise(resolve => {
    const script = document.createElement('script')
    script.src = url
    script.type = 'text/javascript'
    document.body.appendChild(script)
    script.onload = () => {
      resolve()
    }
  })
}

export async function chooseWxImage() {
  await wxworkConfig({
    jsApiList: ['chooseImage']
  })
  return await new Promise((resolve, reject) => {
    wx.chooseImage({
      count: 1, // 默认9
      sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
      sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      success: function (res) {
        // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
        console.log('chooseImage res', res)
        console.log('chooseImage localIds', res.localIds)
        resolve(res)
      },
      fail: function (err) {
        console.error('chooseImage error', err)
        reject(err)
      }
    })
  })
}

export async function uploadWxImage(localId) {
  await wxworkConfig({
    jsApiList: ['uploadImage']
  })
  return await new Promise((resolve, reject) => {
    wx.uploadImage({
      localId, // 需要上传的图片的本地ID，由chooseImage接口获得
      isShowProgressTips: 1, // 默认为1，显示进度提示
      success: function (res) {
        // 返回图片的服务器端ID
        console.log('uploadWxImage serverId', res.serverId)
        resolve(res)
      },
      fail: function (err) {
        console.error('chooseImage error', err)
        reject(err)
      }
    })
  })
}
/**
 * @param {Object} params
 * @param {string} params.sourceType 来源类型，可选值为 camera album
 * @param {string} params.cameraType 摄像头类型，可选值为 user environment camera，默认值为 camera
 * @returns {Promise<File>}
 */
export async function chooseDomImage(params) {
  return new Promise(resolve => {
    const onchange = e => {
      console.log('chooseDomImage2 onchange', e)
      resolve(e.target.files)
      document.body.removeChild(input)
    }

    const input = document.createElement('input')
    input.type = 'file'
    input.multiple = false
    input.accept = 'image/*'
    if (params.sourceType && params.sourceType === 'camera') {
      if (params.cameraType && params.cameraType === 'user') {
        // 前置摄像头
        input.capture = 'user'
      } else if (params.cameraType && params.cameraType === 'environment') {
        // 后置摄像头
        input.capture = 'environment'
      } else {
        // 默认摄像头
        input.capture = 'camera'
      }
    }
    input.style.display = 'none'
    input.style.position = 'fixed'
    input.style.to = '1000vh'
    input.style.left = '1000vw'

    input.addEventListener('change', onchange, { once: true })
    document.body.appendChild(input)
    input.click()
  })
}

export const chooseImage = chooseDomImage
